module.exports = __webpack_public_path__ + "img/logo2.702eaab8.png";